import { Reducer } from 'redux'

interface SwansReducersMap {
  [swanName: string]: Reducer
}

export const swansReducersMap: SwansReducersMap = {}
